module.exports = __webpack_public_path__ + "img/morning_study2.8d98212d.png";